import React, { Fragment, useRef, useState } from "react";
import styled from "styled-components";
import { Chip, IconButton } from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";
import CommentsPopover from "./CommentsPopover";

const CommentsPopper = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const closePopper = (commentsData) => {
    data.data.comments= commentsData.slice().reverse();
    setAnchorEl(null);
    data.api?.redrawRows({ rowNodes: [data.node] });
  };

  const updateCount = (row_id, length) => {
    data.store.comments[row_id] = length;
  };

  const open = Boolean(anchorEl);

  return (
    <Fragment>
      <StyledCommentIconButton size="small" onClick={handleClick}>
        {data.store.comments[data.node.data.row_id] == "0" ||
        data.store.comments[data.node.data.row_id] == null ||
        data.store.comments[data.node.data.row_id] == undefined ? (
          <StyledCommentIcon size="small" />
        ) : (
          <Chip
            label={data.store.comments[data.node.data.row_id]}
            color="primary"
            clickable
            size="small"
          />
        )}
      </StyledCommentIconButton>
      {open && (
        <CommentsPopover
          open={open}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          updateCount={updateCount}
          list_id={data.listId}
          row_id={data.node.data.row_id}
          closePopper={closePopper}
          uniqueId={data.node.data.uniqueId ?? ''}
        />
      )}
    </Fragment>
  );
};

export default CommentsPopper;

const StyledCommentIconButton = styled(IconButton)`
  && {
    padding: 0px;
    margin: 0px 8px 0px 0px;
  }
`;

const StyledCommentIcon = styled(CommentIcon)`
  && {
    color: #237ff4;
  }
`;
